import { Button } from '@design-system/components/button/button';
import { Modal, PlainModalProps } from '@design-system/components/modal/modal';
import { Typography } from '@design-system/components/typography/typography';

export const SingleExercisePublishModal = ({
  isOpen,
  onClose,
  onContinue,
}: Pick<PlainModalProps, 'isOpen' | 'onClose'> & {
  onContinue: () => void;
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Only one exercise? 🤔"
      modalClassName="w-full md:max-w-[602px]"
      contentClassName="py-10.5 px-8"
      disableBackdropClick={true}
      hideCloseButton
      centerContent
    >
      <div className="flex flex-col gap-6">
        <Typography>
          Most great workouts have more than 1 exercise. Keep editing and add
          some more!
        </Typography>
        <Typography>
          If you are using 1 long video, for an entire workout, that's cool,
          too. Click on "One video is fine."
        </Typography>
        <div className="flex flex-col md:flex-row gap-6 justify-center items-center">
          <Button
            color="neutral"
            variant="text"
            className="w-[210px]"
            onClick={onContinue}
          >
            One video is fine
          </Button>
          <Button color="neutral" className="w-[210px]" onClick={onClose}>
            Keep editing
          </Button>
        </div>
      </div>
    </Modal>
  );
};
